import StatusLegendData from "../../../../../common/components/status-legend/types/status-legend-data";
import StatusLegendStatuses from "../../../../../common/components/status-legend/types/status-legend-statuses";

const getStatusOptions = (): StatusLegendData[] => {
  const statuses: StatusLegendStatuses[] = [
    StatusLegendStatuses.PENDING,
    StatusLegendStatuses.OPTIMIZATION_INTERESTING,
    StatusLegendStatuses.REJECTED,
  ];

  return statuses.map((status) => {
    return {
      status,
    };
  });
};

const orderOptimzierTaxiListingHelper = {
  getStatusOptions,
};

export default orderOptimzierTaxiListingHelper;
